(function () {
  const style = document.createElement('style');
  style.textContent = '.cart-timer{display:none!important}.trustpilot-stars{display:none!important}svg[aria-labelledby*=\"discover\" i]{display:none!important}li:has(svg[aria-labelledby*=\"discover\" i]){display:none!important}';
  document.head.appendChild(style);
})();

function cleanUnderwritingCartBlocks(root = document) {
  root.querySelectorAll('.cart-timer').forEach((el) => {
    el.style.setProperty('display', 'none', 'important');
  });

  root.querySelectorAll('.trustpilot-stars').forEach((el) => {
    const wrapper = el.parentElement;
    if (wrapper) {
      wrapper.style.setProperty('display', 'none', 'important');
    } else {
      el.style.setProperty('display', 'none', 'important');
    }
  });

  root.querySelectorAll('svg[aria-labelledby*=\"discover\" i], [data-payment-method*=\"discover\" i]').forEach((el) => {
    const paymentItem = el.closest('li');
    if (paymentItem) {
      paymentItem.remove();
    } else {
      el.remove();
    }
  });

  root.querySelectorAll('title').forEach((title) => {
    if ((title.textContent || '').trim().toLowerCase() === 'discover') {
      const paymentItem = title.closest('li');
      if (paymentItem) {
        paymentItem.remove();
      } else {
        const svg = title.closest('svg');
        if (svg) svg.remove();
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  cleanUnderwritingCartBlocks();

  const observer = new MutationObserver(() => cleanUnderwritingCartBlocks());
  observer.observe(document.body, { childList: true, subtree: true });

  const stickyAdd = document.querySelector(".cstm-stcky-add");
  if (!stickyAdd) return;

  function handleStickyAdd() {
    // Mobile only
    if (window.innerWidth <= 768) {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

      if (scrollPercent >= 18) {
        stickyAdd.style.display = "block";
      } else {
        stickyAdd.style.display = "none";
      }
    } else {
      // Desktop always show
      stickyAdd.style.display = "block";
    }
  }

  // run on load
  handleStickyAdd();

  // run on scroll and resize
  window.addEventListener("scroll", handleStickyAdd);
  window.addEventListener("resize", handleStickyAdd);
});